import { render, staticRenderFns } from "./ModalAsignar.vue?vue&type=template&id=a04a9114"
import script from "./ModalAsignar.vue?vue&type=script&lang=js"
export * from "./ModalAsignar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a04a9114')) {
      api.createRecord('a04a9114', component.options)
    } else {
      api.reload('a04a9114', component.options)
    }
    module.hot.accept("./ModalAsignar.vue?vue&type=template&id=a04a9114", function () {
      api.rerender('a04a9114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/globals/aspectos/ModalAsignar.vue"
export default component.exports